import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkCustomer = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setCustomer(res.data);
    } catch {
      setCustomer(null);
    }
  }, []);

  const checkOwner = useCallback(async () => {
    const token = localStorage.getItem("vytali_rest_token");
    if (!token) return;
    try {
      const res = await api.get("/auth/restaurant/me");
      setOwner(res.data);
    } catch {
      localStorage.removeItem("vytali_rest_token");
      setOwner(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await Promise.all([checkCustomer(), checkOwner()]);
      setLoading(false);
    })();
  }, [checkCustomer, checkOwner]);

  const logoutCustomer = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    setCustomer(null);
  };

  const logoutOwner = () => {
    localStorage.removeItem("vytali_rest_token");
    setOwner(null);
  };

  const loginOwner = (token, ownerData) => {
    localStorage.setItem("vytali_rest_token", token);
    setOwner(ownerData);
  };

  return (
    <AuthContext.Provider value={{
      customer, owner, loading, setCustomer,
      checkCustomer, checkOwner, logoutCustomer, logoutOwner, loginOwner,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
